import React from "react";
import { createStyles, Box, Image } from "@mantine/core";

import SigmalyLogoWhite from "../assets/sigmaly-logo-white.png";
import SigmalyLogoBlack from "../assets/sigmaly-logo-black.png";

function AppLogo({ variant = 'white', ...otherProps }) {
  const { classes } = useStyles();
  const logoSrc = variant === 'black' ? SigmalyLogoBlack : SigmalyLogoWhite;

  return (
    <Box className={classes.container} {...otherProps}>
      <Image width={200} src={logoSrc} alt='Sigmaly AI Logo' />
    </Box>
  );
}

export default AppLogo;

const useStyles = createStyles({
  container: {},
});
